module.exports = __webpack_public_path__ + "static/media/TheHulk.bacd78e0.png";